import create from 'zustand';
import store from './globalFeedback.vanilla.store';

const useStore = create(store);

export default useStore;
